import { render, staticRenderFns } from "./FinalboardTable.vue?vue&type=template&id=4792fbcc&scoped=true"
import script from "./FinalboardTable.vue?vue&type=script&lang=js"
export * from "./FinalboardTable.vue?vue&type=script&lang=js"
import style0 from "./FinalboardTable.vue?vue&type=style&index=0&id=4792fbcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4792fbcc",
  null
  
)

export default component.exports